/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddPaymentCommand } from '../models/AddPaymentCommand';
import type { LCRepaymentPayload } from '../models/LCRepaymentPayload';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PaymentHistoriesService {
    /**
     * @param loanId
     * @param requestBody
     * @returns string Created
     * @throws ApiError
     */
    public static postApiPaymentHistories(
        loanId: string,
        requestBody?: AddPaymentCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/PaymentHistories/{LoanId}',
            path: {
                'LoanId': loanId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param lcId
     * @param requestBody
     * @returns string Created
     * @throws ApiError
     */
    public static postApiPaymentHistoriesLetterOfCredit(
        lcId: string,
        requestBody?: LCRepaymentPayload,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/PaymentHistories/letterOfCredit/{lcId}',
            path: {
                'lcId': lcId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
